import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { LiveRunningFlag, Toast } from "~components/atoms";
import { useStreamContext } from "~contexts/Stream";
import Routes from "./react/routes";
import { useAuth } from "~contexts/Auth";

const App = () => {
  const location = useLocation();
  const { signed } = useAuth();
  const { stream, loading } = useStreamContext();
  const [isLive, setIsLive] = useState<boolean>(false);
  const isLoginRoute = location.pathname === "/";

  useEffect(() => {
    if (!loading && stream && signed) {
      setIsLive(!!stream.is_live && !stream.video.isRerun);
    }
  }, [stream, loading, signed]);

  return (
    <>
      {isLive && !isLoginRoute && <LiveRunningFlag />}
      {/*
      Ocultando miniplayer até que os problemas relacionados a ele estejam resolvidos.
      Os problemas foram descritos nos comentários do card no JIRA => 
      https://gruposoma.atlassian.net/browse/FW-1524?atlOrigin=eyJpIjoiM2NhMzQ1N2VhYWU0NDhkM2E3Zjg0Y2ZmYzc2M2UzODMiLCJwIjoiaiJ9
      */}
      {/* {stream && !isLoginRoute && <Player />} */}
      <Toast />
      <Routes />
    </>
  );
};

export default App;
